(() => {
  function initialize(root) {
    if (root.dataset.pkrReady) return;
    root.dataset.pkrReady = 'true';
    root.querySelectorAll('[data-pkr-step]').forEach(button => button.addEventListener('click', () => {
      const input = button.closest('form').querySelector('[name=quantity]');
      const min = Number(input.min) || 1;
      const max = Number(input.max) || 9999;
      const quantity = Number(input.value) || min;
      input.value = Math.max(min, Math.min(max, quantity + Number(button.dataset.pkrStep)));
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    const form = root.querySelector('[data-pkr-test-form]');
    if (form) {
      const button = form.querySelector('[data-pkr-test-add]');
      const cart = form.querySelector('[data-pkr-test-cart]');
      const add = () => {
        if (!form.reportValidity()) return;
        const count = Number(form.elements.quantity.value);
        cart.querySelector('[data-pkr-count]').textContent = form.dataset.countLabel.replace('%count%', count);
        cart.querySelector('[data-pkr-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'nl', {style: 'currency', currency: form.dataset.currency || 'EUR'}).format(Number(form.dataset.price) * count / 100);
        cart.hidden = false;
      };
      button.disabled = false;
      button.addEventListener('click', add);
      form.addEventListener('submit', event => {event.preventDefault(); add();});
      form.querySelector('[data-pkr-cart-reset]').addEventListener('click', () => {cart.hidden = true; button.focus();});
    }
    root.querySelectorAll('[data-pkr-open-view]').forEach(button => button.addEventListener('click', () => {
      const tab = [...root.querySelectorAll('[data-pkv-view]')].find(tab => tab.dataset.pkvView === button.dataset.pkrOpenView);
      if (!tab) return;
      tab.click();
      tab.focus({preventScroll: true});
      tab.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
  }
  const initializeAll = container => container.querySelectorAll('[data-pkr-product]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
